import { styled } from 'styled-components';

import { Box, InputLabel, Paper, Typography } from '@mui/material';

export const PlaceholderText = styled(Typography)`
  font-size: 0.9rem;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70%;
  padding: 0.25em 0.6em 0.25em 0.6em;
`;

export const SelectAllBox = styled(Box)`
  justify-content: flex-start;
  display: flex;
  padding-top: 8px;
  padding-bottom: 8px;
  padding-left: 25px;
`;

export const WrapperPaperList = styled(Paper)`
  width: fit-content;
  white-space: nowrap;
`;

export const TruncatedInputLabel = styled(InputLabel)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 8px);
  pointer-events: auto;
`;
